import { render, staticRenderFns } from "./IdPhoto.vue?vue&type=template&id=2c96dc90&scoped=true"
import script from "./IdPhoto.vue?vue&type=script&lang=js"
export * from "./IdPhoto.vue?vue&type=script&lang=js"
import style0 from "./IdPhoto.vue?vue&type=style&index=0&id=2c96dc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96dc90",
  null
  
)

export default component.exports